<template>
<div>
  <div class="contact__info">
    <div class="first-col">
      <span class="fal fa-envelope"></span>
    </div>

    <div>
      <div>
      <h3>{{ company.name }}</h3>

      <p class="text-small">
        Buchen Sie jetzt eine Ferienwohnung auf Usedom.
      </p>

      <ul class="text-small">
        <li>
          <span>Adresse:</span>
          {{ company.street }}, {{ company.zip }} {{ company.city }}
        </li>

        <li>
          <span>Telefon:</span>
          <a :href="'tel:' + company.phone">
            {{ company.phone }}
          </a>
        </li>

        <li>
          <a :href="`mailto:${company.email}`"
             title="Oder senden Sie uns eine E-Mail">
              Oder senden Sie uns eine E-Mail
          </a>
        </li>
      </ul>
      </div>
    </div>
  </div>

  <div class="contact__info">
    <div class="first-col">
      <span class="fal fa-map-marker-alt"></span>
    </div>

    <div>
      <div>
        <h3>Ihr Weg zu uns</h3>

        <p class="text-small">
          Nehmen Sie mit uns Kontakt auf oder besuchen Sie uns direkt persönlich auf der Insel.
        </p>

        <standard-map :value="mapCenter" :zoom="mapZoom" @initialized="onMapLoad" height="15rem"></standard-map>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import StandardMap from "../StandardMap.vue";

export default {
  name: "ContactCompanyInfo",

  components: {
    StandardMap
  },

  data() {
    return {
      map: null,
      mapCenter: null,
      mapMarker: null,
      mapLoaded: false,
    }
  },

  computed: {
    company() {
      return this.$yeti.company();
    },

    mapZoom() {
      return 13;
    }
  },

  methods: {
    onMapLoad(o) {
      o.defaultCenter = [54.121360, 13.841100];
      o.L.marker(o.defaultCenter).addTo(o.map);
      this.mapCenter = o.defaultCenter;
    }
  }
}
</script>
